import { zodResolver } from '@hookform/resolvers/zod';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Form, Row } from "react-bootstrap";
import { AsyncTypeahead, Loader } from 'react-bootstrap-typeahead';
import { useFieldArray, useForm } from 'react-hook-form';
import { map, z } from 'zod';
import { ProfissionaisService } from '../../../../services/api/Profissionais/ProfissionaisService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons';
import { float2moeda, moeda2float } from '../../../../utils/Funcoes';
import ServicosProfissionaisList from './ServicosProfissionaisList';
import ModalSimNao from '../../../../components/ModalSimNao';
import { ServicosService } from '../../../../services/api/Servicos/ServicosService';

const ServicosProfissionais = ({ idServico, navigate, servico }) => {

    const profissionaisObj = z.object({
        profissionaisId: z.coerce.string(),
        idServicoProfissionais: z.coerce.string(),
        nome: z.coerce.string(),
        possuiComissao: z.coerce.string(),
        tipoComissao: z.coerce.string(),
        valorComissao: z.coerce.string(),
        valor: z.coerce.string(),
        status: z.coerce.string(),
    })
    const scheme = z.object({
        servicosId: z.coerce.string(),
        profissionais: z.array(profissionaisObj)
    });


    const [profissionaisData, setProfissionaisData] = useState(null)
    const [listProfissionais, setListProfissionais] = useState([])
    const [profissionaisExcluidos, setProfissionaisExcluios] = useState([])
    const [msgForm, setMsgForm] = useState({ variant: null, msg: null })
    const [isLoading, setIsloading] = useState(false)
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [idProcProfSelected, setIdProcProfSelected] = useState({ idProcProf: null, index: null })
    const [profModalAdd, setProfModalAdd] = useState(null)
    const typeaheadDoutor = useRef(null)

    const { register, handleSubmit, watch, setValue, formState: { errors }, control } = useForm({
        mode: 'Blur',
        resolver: zodResolver(scheme),
        values: profissionaisData
    })


    const fetchConv = async () => {
        setIsloading(true)
        const listProcProfissionais = await fetchServicosProfissionais()
        let convs = []
        if (listProcProfissionais) {
            listProcProfissionais?.map((item) => {
                convs.push({
                    ...item,
                    idServicoProfissionais: item.id,
                    nome: item?.profissionais?.nome,
                    valor: float2moeda(item?.valor)
                })
            })

            setValue('profissionais', convs)
        }
        setValue('servicosId', idServico)
        setIsloading(false)
    }

    useEffect(() => {

        fetchConv()

    }, [])

    const { fields: profissionaisFields, append, remove } = useFieldArray({ control, name: 'profissionais' })

    const fetchProfissionais = async (busca) => {
        const data = await ProfissionaisService.getAll(busca)
        return data.data;
    }
    const fetchServicosProfissionais = async (busca) => {
        const data = await ServicosService.getProfissionaisVinculados(idServico, busca, {})
        return data.data;
    }


    const handleSearchProfissionais = async (busca) => {
        const convs = await fetchProfissionais(busca);
        let list = []
        if (convs) {
            convs?.map((profs) => {
                let verifica = profissionaisFields.find(pf => pf.profissionaisId == profs.id)
                if (verifica == undefined) {
                    list.push(profs)
                }
            })
            setListProfissionais(list)
        }
    }
    const handleChangeProfissionaisAdd = (item) => {


        if (item != undefined && item.length > 0) {
            const dadosProf = {
                profissionaisId: item[0].id,
                nome: item[0].nome,
                possuiComissao: 0,
                valor: 0,
                status: 1
            }
            append(dadosProf)


            salvarNovoProfissional(dadosProf)
        }
        typeaheadDoutor.current.clear()
        return false;
    }

    const handleRemoveConv = (campo, index) => {

        setShowConfirmDelete(true)
        setIdProcProfSelected({ idProcProf: campo.idServicoProfissionais, index: index })
        // console.log(campo)
        let convs = profissionaisExcluidos
        convs.push(campo.idServicoProfissionais)



    }

    const handleCloseConfirmDel = async () => {
        setShowConfirmDelete(false)
        setIdProcProfSelected({ idProcProf: null, index: null })
    }
    const handleDeleteProf = async () => {
        setProfissionaisExcluios([idProcProfSelected.idProcProf])

        //fazer exclusao pela api
        remove(idProcProfSelected.index)
    }

    //console.log(profissionaisFields)

    const salvarNovoProfissional = async (dados) => {
        console.log(dados)

        const dataForm = {
            profissionais: [{
                id: dados.profissionaisId,
                possuiComissao: 0,
            }]
        }

        const dataApi = await ServicosService.vincularProfissionais(idServico, dataForm);
        if (dataApi.success) {
            setProfModalAdd({
                id: dados.profissionaisId,
                nome: dados.nome,
            })
        }
        console.log(dataApi)
    }


    const onSubmit = async (data, fechar) => {

        console.log(data)
        //  console.log(profissionaisExcluidos)
        return false;
        let DataForm = data
        DataForm.profissionaisExcluidosIds = profissionaisExcluidos

        let profissionaisPost = []
        data?.profissionais?.map((item) => {
            console.log(item)
            profissionaisPost.push({
                ...item,
                id: item.profissionaisId,
                valor: moeda2float(item.valor)
            })

        })
        DataForm.profissionais = profissionaisPost
        try {
            const dataApi = await ServicosService.vincularProfissionais(idServico, DataForm);
            if (dataApi.success) {
                console.log(navigate)
                if (fechar) {
                    navigate('/configuracoes/procedimentos')
                } else {

                    setMsgForm({
                        variant: 'success',
                        msg: dataApi.msg
                    })
                }

            } else {
                setMsgForm({
                    variant: 'danger',
                    msg: dataApi.msg
                })
            }
        } catch (error) {
            setMsgForm({
                variant: 'danger',
                msg: error
            })
        }




    }
    return (
        <>
            <div className='alert alert-info'>
                Adicione/remova aqui os profissionais que realizam este serviço e as configurações de comissões
            </div>
            <Row>
                <Form.Group as={Col} sm={6}>
                    <Form.Label>Adicionar profissionais</Form.Label>
                    <AsyncTypeahead
                        ref={typeaheadDoutor}
                        clearButton
                        filterBy={() => true}
                        id='buscaProfissional'
                        labelKey={(option) => option.nome}
                        minLength={3}
                        onSearch={handleSearchProfissionais}
                        onChange={handleChangeProfissionaisAdd}
                        options={listProfissionais}
                        placeholder='Digite o nome do profisssional'
                        renderMenuItemChildren={(option) => (
                            <>
                                {option.nome} {option?.profissional_especialidades?.nome}
                            </>)}

                    />
                </Form.Group>
            </Row>
            <br></br>
            <Form>


                <div  className='container-fluid'>

                    {(isLoading) ? <Loader /> :

                        <ServicosProfissionaisList
                            fetchConv={fetchConv}
                            servico={servico}
                            idServico={idServico}
                            profissionaisFields={profissionaisFields}
                            handleRemoveConv={handleRemoveConv} 
                            profModalAdd={profModalAdd}
                            setProfModalAdd={setProfModalAdd}
                            remove={remove}
                            />


                    }
                </div>
                <br></br>

                <div className={`alert alert-${msgForm.variant}`} style={{ display: (msgForm.msg != null) ? '' : 'none' }}>{msgForm.msg}</div>
                <div className="text-center ">
                    <Button variant="danger" size="sm" className="mr-15" href="/admin/configuracoes/procedimentos"><FontAwesomeIcon icon={faChevronCircleLeft} /> Voltar</Button>
                    { /**     <Button variant="primary" onClick={() => handleSubmit(onSubmit)()}>Salvar</Button>
                                     <Button variant="primary" onClick={() => handleSubmit(onSubmit)(true)} className="ml-15">Salvar e Fechar</Button>*/}
                </div>
            </Form >


            <ModalSimNao show={showConfirmDelete} handleClose={handleCloseConfirmDel} handleConfirm={handleDeleteProf} >
                Tem certeza que deseja excluir todos as comissões deste profissional?
            </ModalSimNao>
        </>
    )

}

export default ServicosProfissionais; 